// extracted by mini-css-extract-plugin
export default {"root":"Siu7gVl3lfvEJCJZqHmM","details":"Bx6d_b7fvGDkBvahqvVp","name":"DKbtxq8WMmvfvnGRwTaT","icon":"F9B5_izcYjxi26aMREL0","description":"Vh_iVlxiPiI2o7aVzh1s"};